<template>
  <div>
    <div class="d_flex_btwn">
      <h1 class="common_title">
        <span>Import Ticket</span>
      </h1>
      <span>
        <router-link :to="{name: 'tickets'}" class="btn btn_black">Back to List</router-link>
      </span>
    </div>
    <div class="card border_none">
      <div class="card_body pl_0 pr_0">
        <div class="row">
          <div class="col_12 pl_20">
            <div class="custom_tab_content_inner">
              <div class="product_list_wrap p_relative">
                <h3>Upload File</h3>
                <div class="upload_btn mt_5 mb_10" :class="[{'has_error': errorFor('file')}]">
                  <input type="file" class="form_input" @change="handleFileUpload"/>
                  <v-errors :errors="errorFor('file')"></v-errors>
                </div>
              </div>
            </div>
            <div class="form_row">
              <label></label>
              <div class="form_inline">
                <button v-if="lyLoading" class="btn btn_primary" :disabled="lyLoading">Processing...</button>
                <button v-else class="btn btn_primary" :disabled="lyLoading" @click.prevent="submit">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'ticket-form',
  data() {
    return {
      lyLoading: false,
      selectedFile: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    })
  },
  mounted() {
  },
  methods: {
    handleFileUpload(event) {
      this.selectedFile = event.target.files[0];
    },
    async submit() {
      if (!this.selectedFile) {
        alert('Please select a file.');
        return;
      }
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData()

      formData.append('file', this.selectedFile);

      await this.axios.post('/import-ticket', formData)
          .then(({ data }) => {
            if (data.success) {
              setTimeout(() => {
                this.resetForm();
                this.showSuccessMsg("Ticket Imported Successfully!");
                this.$router.push({name: 'tickets'})
                this.lyLoading = false;
              }, 3000)
            } else {
              this.showFailMsg("Ticket Import fail! Please try again.");
            }
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors
            this.showFailMsg(err.response.data.message);
            this.lyLoading = false;
          })
    },
    resetForm() {
      this.selectedFile = null
    },
  }
}
</script>
<style scoped lang="scss">

</style>
